import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15e9f802"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "label" }
const _hoisted_5 = { class: "modal-footer" }

import GenericButton from "@/components/buttons/GenericButton.vue";
import { GenericButtonVariantEnum } from "@/types/button";

interface Props {
  title?: string;
  label?: string;
  btnText?: string;
  cancelBtnText?: string;
  cancelAction: () => void;
  saveAction: () => void;
  closeAction: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoModal',
  props: {
    title: { default: "" },
    label: { default: "" },
    btnText: { default: "" },
    cancelBtnText: { default: "" },
    cancelAction: { type: Function, default: () => {} },
    saveAction: { type: Function, default: () => {} },
    closeAction: { type: Function, default: () => {} }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modalWrapper",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeAction && _ctx.closeAction(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.title)), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.label)), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(GenericButton, {
          variant: _unref(GenericButtonVariantEnum).Primary,
          text: _ctx.btnText,
          "on-click": _ctx.saveAction
        }, null, 8, ["variant", "text", "on-click"]),
        _createVNode(GenericButton, {
          variant: _unref(GenericButtonVariantEnum).Terciary,
          text: _ctx.cancelBtnText,
          "on-click": _ctx.cancelAction
        }, null, 8, ["variant", "text", "on-click"])
      ])
    ])
  ]))
}
}

})